export const GET_PUBLIC_HOLIDAYS = "get_public_holidays";
export const EDIT_SYSTEM_SETTING = "edit_system_setting";
export const START_LOADING = "start_loading";
export const STOP_LOADING = "stop_loading";
export const HOLIDAY_ERROR = "holiday_error";
export const ACCESS_RIGHT_ERROR = "access_error";
